import { all } from "redux-saga/effects";
import { thongKeSiSoSaga } from "./thongKeSiSoSaga";
import { thongKeCSKHSaga } from "./thongKeCSKHSaga";
import { thongKeCRMSaga } from "./thongKeCRMSaga";

export default function* thongKeSagaWrapper() {
    yield all([
        thongKeSiSoSaga(),
        thongKeCSKHSaga(),
        thongKeCRMSaga()
    ])
}